<template>
    <div class="w-100 border-0 mb-primary">

        <app-overlay-loader v-if="preloader"/>
            <form ref="form" data-url="/form/multiple-files" class="mb-0" :class="{'loading-opacity': preloader}">

                <div class="form-group row mb-0">

                    <div class="col-sm-12 pr-0">
                        <app-input type="dropzone"
                                   v-model="dropzone_files"/>

                    </div>
                </div>
                <div class="mt-2 action-buttons multiple-files-upload-btn" style="display:none;">
                    <button type="submit" class="btn btn-primary mr-2" :title="$t('recommended_dropzone_file_validation')" @click.prevent="submit">
                        {{ $t('upload') }}
                    </button>
                </div>
            </form>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../../core/mixins/form/FormMixin.js';

    export default {
        name: "FormFiles",
        mixins: [FormMixin],
        props: {
           candidateId: String,
           formId: String,
        },
        data() {
            return {
                preloader: false,
                dropzone_files: [],
                tableId: 'file-table',
                parsedCv: '',
            }
        },

        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData();
                if (this.dropzone_files.length) {
                    this.dropzone_files.forEach(dropzone_file => formData.append(`dropzone_file[]`, dropzone_file));

                    // formData.append("dropzone_file", this.inputs.default_file);
                    if(this.candidateId){
                        formData.append("candidate_id", this.candidateId);
                    } else if (this.formId) {
                        formData.append("form_id", this.formId);
                    }

                }
                this.save(formData);
            },
            afterSuccess(res) {
                if(res.data.message == ''){
                    this.$toastr.s(this.$t('file_succesfully_uploaded'));
                } else {
                    this.$toastr.s(res.data.message);
                }


                this.dropzone_files = null;

                $('.multiple-files-upload-btn').hide();
                console.log(res.data);
                console.log('data uploaded');

                // If fields phone/mail/linkedin
                let parseDocUrl = res.data.input.dropzone_file.split("/");
                var parseDoc = parseDocUrl[parseDocUrl.length - 1];

                // For testing purponses on localhost (where cv parser not installed)
                if (location.hostname === "localhost" || location.hostname === "127.0.0.1"){
                    this.parsedCv = {"email":["testovaci@adresa.cz","klubik@silicon.eu"],"mobile":["+420 123 456 789"]};
                    this.$emit('parsed-cv', this.parsedCv);

                } else {
                    this.axiosGet('files/cv?file='+parseDoc).then(response => {

                        this.parsedCv = response.data;
                        console.log(this.parsedCv);
                        this.$emit('parsed-cv', this.parsedCv);

                    }).catch(({response}) => {
                    }).finally(() => {
                    });

                }




            },
            afterFinalResponse() {
                this.preloader = false;
                this.$hub.$emit('reload-'+this.tableId);
            },
            afterError({data, status}) {
                if(status === 422)
                    this.$toastr.e(this.$t('file_size_limit_exceeded'));
                else this.$toastr.e(data.message);
            }
        }
    }
</script>
